<template>
    <transition name="modal">
        <div class="modal-mask" @mousedown.self="armClose" @mouseup.self="maybeClose" @mouseup="disarmClose" v-if="isShowing">
            <div class="modal-container" :class="{ 'modal-lg': large }">
                <div class="modal-dialog" :class="{ 'modal-lg': large }">
                    <div class="modal-content">
                        <div class="modal-header">
                            <button type="button" class="close" @click="hide">
                                <span>&times;</span>
                            </button>

                            <h4 class="modal-title">
                                <slot name="header" :text="header">{{ header }}</slot>
                            </h4>
                        </div>

                        <div class="modal-body">
                            <slot />
                        </div>

                        <div class="modal-footer" v-if="$slots.footer">
                            <slot name="footer"></slot>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<style>
.modal-mask {
    position: fixed;
    z-index: 1040;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
}

.modal-container {
    max-width: 600px;
    margin: 40px auto;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
}

.modal-container.modal-lg {
    max-width: 900px;
}

.modal-content {
    max-height: calc(100vh - 80px);
    display: flex;
    flex-direction: column;
}

.modal-body {
    overflow: auto;
}

.modal-enter-active, .modal-leave-active {
    transition: all 0.3s ease;
}

.modal-enter, .modal-leave-active {
    opacity: 0;
    -webkit-transform: scale(1.03);
    transform: scale(1.03);
}

.body-no-scroll {
    overflow: hidden;
}
</style>


<script>
export default {
    props: ['header', 'alwaysShow', 'large'],
    data() {
        return {
            isShowing: false,
            shouldClose: false,
        };
    },
    created() {
        if (this.alwaysShow)
            this.isShowing = true;
    },
    beforeDestroy() {
        if (this.isShowing)
            this.hidden();
    },
    watch: {
        isShowing(value) {
            if (value)
                this.shown();
            else
                this.hidden();
        },
    },
    methods: {
        show: function() {
            if (this.isShowing)
                return;

            let args = { cancel: false };
            this.$emit('show', args);
            if (args.cancel)
                return;

            this.isShowing = true;
        },
        shown() {
            this.$modals.$shown(this);
            this.$emit('shown');
        },
        armClose() {
            this.shouldClose = true;
        },
        disarmClose() {
            this.shouldClose = false;
        },
        maybeClose() {
            if (this.shouldClose) {
                this.shouldClose = false;
                this.hide();
            }
        },
        hide: function (x) {
            if (!this.isShowing)
                return;

            let args = { cancel: false };
            this.$emit('hide', args);
            if (args.cancel)
                return;

            if (this.alwaysShow)
                return;

            this.isShowing = false;
        },
        hidden() {
            this.$modals.$hidden(this);
            this.$emit('hidden');
        },
    }
}
</script>
